var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 29.5 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M2.2 66.2V53.6h7.7M2.2 59.9h7.7M17.4 66.4V53.8c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.9-8.6 3.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFp);
export default __webpack_public_path__ + "static/media/FP.ba675e6a6570759ffed30ede7f901095.svg";
export { ForwardRef as ReactComponent };